import React from "react";
import { MDBAnimation, MDBIcon } from "mdbreact";
import "./style.css";

export default function Pioneers() {
  const PUBLIC_URL = process.env.PUBLIC_URL || "";
  const EMMAN = `${PUBLIC_URL}/assets/images/landing/pioneers/emman.jpg`;
  const TOMAS = `${PUBLIC_URL}/assets/images/landing/pioneers/tomas.jpg`;
  const RIC = `${PUBLIC_URL}/assets/images/landing/pioneers/ric.jpg`;
  const JERWIN = `${PUBLIC_URL}/assets/images/landing/pioneers/jerwin.jpg`;
  const RICO = `${PUBLIC_URL}/assets/images/landing/pioneers/rico.png`;
  const MAGTALAS = `${PUBLIC_URL}/assets/images/landing/pioneers/kevin.png`;
  const NICK = `${PUBLIC_URL}/assets/images/landing/pioneers/nick.png`;
  const MELUIN = `${PUBLIC_URL}/assets/images/landing/pioneers/meluin.jpg`;

  const PIONEERS = [
    {
      name: "Thomas Emmanuel R.Pajarillaga",
      role: "CTO",
      quote: "Transforming ideas into seamless and intuitive web experiences.",
      img: EMMAN,
      socials: {},
    },
    {
      name: "Tomas B. Pajarillaga Jr.RMT, RN, MSIT",
      role: "CEO",
      quote:
        "Powering applications with robust and efficient server-side functionality.",
      img: TOMAS,
      socials: {},
    },
    {
      name: "Jerwin Jay J. Romero",
      role: "Project Manager",
      quote: "Think. Code. Debug. Repeat.",
      img: JERWIN,
      socials: {},
    },
    {
      name: "Ric Darrel A. Pajarillaga",
      role: "Lead Software Engineer(Backend)",
      quote: "Building scalable and efficient web applications.",
      img: RIC,
      socials: {},
    },
    {
      name: "Kevin P. Magtalas",
      role: "Lead Software Engineer(Frontend)",
      quote: "I'm not a magician, I'm a software engineer.",
      img: MAGTALAS,
      socials: {},
    },
    {
      name: "Reynald Nick P. Magtalas",
      role: "Senior Software Engineer",
      quote: "Success is a series of small wins.",
      img: NICK,
      socials: {},
    },

    {
      name: "John Rico S. Avila",
      role: "Junior Software Engineer",
      quote: "First, solve the problem. Then, write the code.",
      img: RICO,
      socials: {},
    },
    {
      name: "Dan Meluin M. Palaris",
      role: "Junior Software Engineer",
      quote: "Software grows, evolves, and never finishes.",
      img: MELUIN,
      socials: {},
    },
  ];
  return (
    <section className="team-section text-center">
      <MDBAnimation reveal type="fadeInDown" duration="1.5s" delay=".5s">
        <h1 className="homePage-pioneers-title text-center mt-5 h1">
          Pioneers
        </h1>
      </MDBAnimation>
      <MDBAnimation reveal type="fadeInDown" duration="1.5s" delay="1s">
        <p
          className="text-center mb-5 w-responsive mx-auto"
          style={{ fontWeight: "400" }}
        >
          Our team is composed of talented professionals with diverse expertise,
          working collaboratively to deliver exceptional results for our
          clients.
        </p>
      </MDBAnimation>

      <div className="homePage-pioneers-container">
        {PIONEERS.map((pioneer, index) => (
          <MDBAnimation
            reveal
            type="fadeInUp"
            duration="1.5s"
            delay={`${index * 0.2}s`}
            className="homePage-pioneers-card"
            key={index}
          >
            <img src={pioneer.img} alt="avatar" loading="lazy" />
            <span>{pioneer.name}</span>
            <p>{pioneer.role}</p>
            {(pioneer.socials?.linkedin ||
              pioneer.socials?.facebook ||
              pioneer.socials?.twitter) && (
              <div
                className="d-flex align-items-center"
                style={{ gap: "15px" }}
              >
                {pioneer.socials?.linkedin && (
                  <a
                    href={pioneer.socials.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pioneerAvatarLink"
                  >
                    <MDBIcon fab icon="linkedin" />
                  </a>
                )}
                {pioneer.socials?.facebook && (
                  <a
                    href={pioneer.socials.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pioneerAvatarLink"
                  >
                    <MDBIcon fab icon="facebook-f" />
                  </a>
                )}
                {pioneer.socials?.twitter && (
                  <a
                    href={pioneer.socials.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pioneerAvatarLink"
                  >
                    <MDBIcon fab icon="twitter" />
                  </a>
                )}
              </div>
            )}
          </MDBAnimation>
        ))}
      </div>
    </section>
  );
}
